<template>
<div class="popup" v-cloak v-if="decryptShow">
    <div class="content" id="decrypt">
        <div class="title">
            {{$t('language.common.decrypt')}}
            <div class="icon white-close dialog-close" @click="decryptShow=false"></div>
        </div>
        <div class="decrypt-content">
            <span>{{$t('language.popup.personalCenter.pleaseSwitch')}}</span>
        </div>
        <div class="decrypt-footer">
            <button style="float:right;" class="decrypt-button" @click="switchOldVersion">{{$t('language.popup.personalCenter.switchOld')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            decryptShow: false
        }

    },
    methods: {
        switchOldVersion() {
            let language = commonUtils.getLocaleTo(localStorage.getItem("locale"));
            var tmp = new Date().getTime();
            window.location.href = commonstate.oldVersionUrl + "/index.jsp?rl=" + language + "&tmp=" + tmp + "#home";
        }
    }
}
</script>

<style>
#decrypt {
    width: 510Px;
    height: 195Px;
}

.decrypt-content {
    width: 100%;
    /*no*/
    height: 102px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    line-height: 90px;
    /*no*/
}

.decrypt-footer {
    width: 100%;
    height: 28px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
}

.decrypt-button {
    border-radius: 5Px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/decrypt_popup.vue